import Enum from '@bilibili/magic-bag/enum';

// 商品类型
export const CUSTOMER_TYPE = new Enum(
    { key: 'ZHI_CHI', value: 1, text: '智齿客服' },
    { key: 'SI_XIN', value: 2, text: '私信客服' },
    { key: 'ZI_YAN', value: 3, text: '自研客服' },
    { key: 'XIN_ZI_YAN', value: 99, text: '新自研客服' }
);

// 企业类型的商家类型
export const BUSINESS_TYPE = new Enum(
    { key: 'PERSONAL', value: 1, text: '个人商家' },
    { key: 'INDIVIDUAL_BUSINESSES', value: 2, text: '个体户商家' },
    { key: 'ENTERPRISE', value: 3, text: '企业商家' }
);

export const a = {};
